import { MessageTopic } from '../models/message-type';

export const topics: MessageTopic[] = [
  {
    messageTopicId: 1,
    topic: 'Non-Urgent Medical Question',
    description: "Message my provider's office a question that does not require an immediate response.",
  },
  {
    messageTopicId: 2,
    topic: 'Medication Question or Refill',
    description: 'Message clinical staff regarding a medication question or refill request.',
  },
  {
    messageTopicId: 3,
    topic: 'Appointment Question or Request',
    description: 'Message scheduling staff to request or inquire about an appointment.',
  },
  {
    messageTopicId: 4,
    topic: 'Medical Records Request',
    description: 'Message Medical Records for records or questions about your patient chart.',
  },
];
